// 非父子组件传参
import Vue from "vue";
export default new Vue();